/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import SubstanceUseRow from "./SubstanceUseRow"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { confirmation } from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { Dropdown } from "primereact/dropdown"
import FormError from "../../../Common/FormError"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { INTERVIEW_TYPES } from "../../../types/interviewTypes"
import { UserContext } from "../../../../../context/userContext"
const SubstanceUse2 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    handleLoadPrev,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [substanceUse2, setSubstanceUse2] = useState(
    interview[INTERVIEW_SECTIONS.SUBSTANCE_USE_2]
  )
  const [mixedQuestions, setMixedQuestions] = useState([])
  const [validationErrors, setValidationErrors] = useState({})

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SUBSTANCE_USE_2
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SUBSTANCE_USE_2
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_2, substanceUse2)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SUBSTANCE_USE_DATA, {
          GpraBForm: {
            ...substanceUse2,
            gpra_b_2a: substanceUse2?.gpra_b_2a,
            gpra_b_2a_days: substanceUse2?.gpra_b_2a_days,
            gpra_b_2b: substanceUse2?.gpra_b_2b,
            gpra_b_2b_days: substanceUse2?.gpra_b_2b_days,
            gpra_b_2c: substanceUse2?.gpra_b_2c,
            gpra_b_2c_days: substanceUse2?.gpra_b_2c_days,
            gpra_b_2d: substanceUse2?.gpra_b_2d,
            gpra_b_2d_days: substanceUse2?.gpra_b_2d_days,
            gpra_b_2e: substanceUse2?.gpra_b_2e,
            gpra_b_2f: substanceUse2?.gpra_b_2f,
            gpra_b_3a: substanceUse2?.gpra_b_3a,
            gpra_b_3a_days: substanceUse2?.gpra_b_3a_days,
            gpra_b_3b: substanceUse2?.gpra_b_3b,
            gpra_b_3b_days: substanceUse2?.gpra_b_3b_days,
            gpra_b_3c: substanceUse2?.gpra_b_3c,
            gpra_b_3c_days: substanceUse2?.gpra_b_3c_days,
            gpra_b_3d: substanceUse2?.gpra_b_3d,
            gpra_b_3d_days: substanceUse2?.gpra_b_3d_days,
            gpra_b_3e: substanceUse2?.gpra_b_3e,
            gpra_b_3f: substanceUse2?.gpra_b_3f,
            gpra_b_4a: substanceUse2?.gpra_b_4a,
            gpra_b_4a_days: substanceUse2?.gpra_b_4a_days,
            gpra_b_4b: substanceUse2?.gpra_b_4b,
            gpra_b_4b_days: substanceUse2?.gpra_b_4b_days,
            gpra_b_4c: substanceUse2?.gpra_b_4c,
            gpra_b_4c_days: substanceUse2?.gpra_b_4c_days,
            gpra_b_4d: substanceUse2?.gpra_b_4d,
            gpra_b_4d_days: substanceUse2?.gpra_b_4d_days,
            gpra_b_4e: substanceUse2?.gpra_b_4e,
            gpra_b_4f: substanceUse2?.gpra_b_4f,
            gpra_b_5a: substanceUse2?.gpra_b_5a,
            gpra_b_5a_days: substanceUse2?.gpra_b_5a_days,
            gpra_b_5b: substanceUse2?.gpra_b_5b,
            gpra_b_5b_days: substanceUse2?.gpra_b_5b_days,
            gpra_b_5c: substanceUse2?.gpra_b_5c,
            gpra_b_5c_days: substanceUse2?.gpra_b_5c_days,
            gpra_b_5d: substanceUse2?.gpra_b_5d,
            gpra_b_5e: substanceUse2?.gpra_b_5e,
          },
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBId: substanceUse2?.gpra_b_id,
          Additional: getAdditionalQuestions(substanceUse2),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ substanceUse2: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const validForm = () => {
    const errors = {}
    if (
      substanceUse2?.gpra_b_2a === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2a = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_2a &&
      substanceUse2?.gpra_b_2a_days === 0 &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2a = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_2b === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2b = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_2b &&
      substanceUse2?.gpra_b_2b_days === 0 &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2b = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_2c === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2c = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_2c &&
      substanceUse2?.gpra_b_2c_days === 0 &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2c = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_2d === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2d = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_2d &&
      substanceUse2?.gpra_b_2d_days === 0 &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2d = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_2e === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2e = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_2f === undefined &&
      showQuestion(questions, "gpra_b_2")
    ) {
      errors.gpra_b_2f = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_3a === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3a = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_3a &&
      substanceUse2?.gpra_b_3a_days === 0 &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3a = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_3b === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3b = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_3b &&
      substanceUse2?.gpra_b_3b_days === 0 &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3b = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_3c === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3c = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_3c &&
      substanceUse2?.gpra_b_3c_days === 0 &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3c = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_3d === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3d = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_3d &&
      substanceUse2?.gpra_b_3d_days === 0 &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3d = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_3e === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3e = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_3f === undefined &&
      showQuestion(questions, "gpra_b_3")
    ) {
      errors.gpra_b_3f = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_4a === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4a = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_4a &&
      substanceUse2?.gpra_b_4a_days === 0 &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4a = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_4b === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4b = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_4b &&
      substanceUse2?.gpra_b_4b_days === 0 &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4b = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_4c === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4c = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_4c &&
      substanceUse2?.gpra_b_4c_days === 0 &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4c = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_4d === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4d = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_4d &&
      substanceUse2?.gpra_b_4d_days === 0 &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4d = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_4e === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4e = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_4f === undefined &&
      showQuestion(questions, "gpra_b_4")
    ) {
      errors.gpra_b_4f = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_5a === undefined &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5a = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_5a &&
      substanceUse2?.gpra_b_5a_days === 0 &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5a = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_5b === undefined &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5b = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_5b &&
      substanceUse2?.gpra_b_5b_days === 0 &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5b = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_5c === undefined &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5c = errorMessages.requiredMessage
    } else if (
      substanceUse2?.gpra_b_5c &&
      substanceUse2?.gpra_b_5c_days === 0 &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5c = errorMessages.daysGreaterThanZero
    }
    if (
      substanceUse2?.gpra_b_5d === undefined &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5d = errorMessages.requiredMessage
    }
    if (
      substanceUse2?.gpra_b_5e === undefined &&
      showQuestion(questions, "gpra_b_5")
    ) {
      errors.gpra_b_5e = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        substanceUse2,
        INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const clearValues = (number) => {
    return [
      { key: `gpra_b_${number}a`, value: false },
      { key: `gpra_b_${number}a_days`, value: 0 },
      { key: `gpra_b_${number}b`, value: false },
      { key: `gpra_b_${number}b_days`, value: 0 },
      { key: `gpra_b_${number}c`, value: false },
      { key: `gpra_b_${number}c_days`, value: 0 },
      { key: `gpra_b_${number}d`, value: false },
      { key: `gpra_b_${number}d_days`, value: 0 },
    ]
  }

  const clearTobaccoValues = (number) => {
    return [
      { key: `gpra_b_${number}a`, value: false },
      { key: `gpra_b_${number}a_days`, value: 0 },
      { key: `gpra_b_${number}b`, value: false },
      { key: `gpra_b_${number}b_days`, value: 0 },
      { key: `gpra_b_${number}c`, value: false },
      { key: `gpra_b_${number}c_days`, value: 0 },
    ]
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_2") {
      return (
        <div className={gpraStyles.substanceUseContainer}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. If you have been diagnosed with an alcohol use disorder, which FDA-approved medication did you receive for the treatment of this alcohol use disorder in the past 30 days? [CHECK ALL THAT APPLY.]`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_2a_days"}
              days={substanceUse2?.gpra_b_2a_days}
              legend="Naltrexone"
              confirmation={substanceUse2?.gpra_b_2a}
              setConfirmation={"gpra_b_2a"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_2a}
              numberErrorType="gpra_b_2a"
              showDays={substanceUse2?.gpra_b_2a === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_2e || substanceUse2?.gpra_b_2f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_2b_days"}
              days={substanceUse2?.gpra_b_2b_days}
              legend="Extended‒release Naltrexone"
              confirmation={substanceUse2?.gpra_b_2b}
              setConfirmation={"gpra_b_2b"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_2b}
              numberErrorType="gpra_b_2b"
              showDays={substanceUse2?.gpra_b_2b === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_2e || substanceUse2?.gpra_b_2f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_2c_days"}
              days={substanceUse2?.gpra_b_2c_days}
              legend="Disulfiram"
              confirmation={substanceUse2?.gpra_b_2c}
              setConfirmation={"gpra_b_2c"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_2c}
              numberErrorType="gpra_b_2c"
              showDays={substanceUse2?.gpra_b_2c === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_2e || substanceUse2?.gpra_b_2f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_2d_days"}
              days={substanceUse2?.gpra_b_2d_days}
              legend="Acamprosate"
              confirmation={substanceUse2?.gpra_b_2d}
              setConfirmation={"gpra_b_2d"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_2d}
              numberErrorType="gpra_b_2d"
              showDays={substanceUse2?.gpra_b_2d === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_2e || substanceUse2?.gpra_b_2f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Did not receive an FDA-approved medication for a diagnosed alcohol use disorder"
              }
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_b_2e
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_2e}
              onChange={(e) => {
                removeError("gpra_b_2e")
                if (e.value) {
                  updateState(
                    "gpra_b_2e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("2")
                  )
                } else {
                  updateState(
                    "gpra_b_2e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_2e}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_2e} />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Client does not report such a diagnosis"} required/>
            <Dropdown
              className={
                validationErrors.gpra_b_2f
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_2f}
              onChange={(e) => {
                removeError("gpra_b_2f")
                if (e.value) {
                  updateState(
                    "gpra_b_2f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("2")
                  )
                } else {
                  updateState(
                    "gpra_b_2f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_2f}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_2f} />
          </div>
        </div>
      )
    }
    if (question.field === "gpra_b_3") {
      return (
        <div className={gpraStyles.substanceUseContainer}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. If you have been diagnosed with an opioid use disorder, which FDA-approved medication did you receive for the treatment of this opioid use disorder in the past 30 days? [CHECK ALL THAT APPLY.]`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_3a_days"}
              days={substanceUse2?.gpra_b_3a_days}
              legend="Methadone"
              confirmation={substanceUse2?.gpra_b_3a}
              setConfirmation={"gpra_b_3a"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_3a}
              numberErrorType="gpra_b_3a"
              showDays={substanceUse2?.gpra_b_3a === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_3e || substanceUse2?.gpra_b_3f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_3b_days"}
              days={substanceUse2?.gpra_b_3b_days}
              legend="Buprenorphine"
              confirmation={substanceUse2?.gpra_b_3b}
              setConfirmation={"gpra_b_3b"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_3b}
              numberErrorType="gpra_b_3b"
              showDays={substanceUse2?.gpra_b_3b === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_3e || substanceUse2?.gpra_b_3f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_3c_days"}
              days={substanceUse2?.gpra_b_3c_days}
              legend="Naltrexone"
              confirmation={substanceUse2?.gpra_b_3c}
              setConfirmation={"gpra_b_3c"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_3c}
              numberErrorType="gpra_b_3c"
              showDays={substanceUse2?.gpra_b_3c === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_3e || substanceUse2?.gpra_b_3f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_3d_days"}
              days={substanceUse2?.gpra_b_3d_days}
              legend="Extended‒release Naltrexone"
              confirmation={substanceUse2?.gpra_b_3d}
              setConfirmation={"gpra_b_3d"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_3d}
              numberErrorType="gpra_b_3d"
              showDays={substanceUse2?.gpra_b_3d === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_3e || substanceUse2?.gpra_b_3f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Did not receive an FDA-approved medication for a diagnosed opioid use disorder"
              }
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_b_3e
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_3e}
              onChange={(e) => {
                removeError("gpra_b_3e")
                if (e.value) {
                  updateState(
                    "gpra_b_3e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("3")
                  )
                } else {
                  updateState(
                    "gpra_b_3e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_2e}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_3e} />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Client does not report such a diagnosis"} required/>
            <Dropdown
              className={
                validationErrors.gpra_b_3f
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_3f}
              onChange={(e) => {
                removeError("gpra_b_3f")
                if (e.value) {
                  updateState(
                    "gpra_b_3f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("3")
                  )
                } else {
                  updateState(
                    "gpra_b_3f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_3f}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_3f} />
          </div>
        </div>
      )
    }
    if (question.field === "gpra_b_4") {
      return (
        <div className={gpraStyles.substanceUseContainer}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. If you have been diagnosed with a stimulant use disorder, which evidence-based interventions did you receive for the treatment of this disorder in the past 30 days?`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_4a_days"}
              days={substanceUse2?.gpra_b_4a_days}
              legend="Contingency Management"
              confirmation={substanceUse2?.gpra_b_4a}
              setConfirmation={"gpra_b_4a"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_4a}
              numberErrorType="gpra_b_4a"
              showDays={substanceUse2?.gpra_b_4a === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_4e || substanceUse2?.gpra_b_4f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_4b_days"}
              days={substanceUse2?.gpra_b_4b_days}
              legend="Community Reinforcement"
              confirmation={substanceUse2?.gpra_b_4b}
              setConfirmation={"gpra_b_4b"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_4b}
              numberErrorType="gpra_b_4b"
              showDays={substanceUse2?.gpra_b_4b === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_4e || substanceUse2?.gpra_b_4f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_4c_days"}
              days={substanceUse2?.gpra_b_4c_days}
              legend="Cognitive Behavioral Therapy"
              confirmation={substanceUse2?.gpra_b_4c}
              setConfirmation={"gpra_b_4c"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_4c}
              numberErrorType="gpra_b_4c"
              showDays={substanceUse2?.gpra_b_4c === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_4e || substanceUse2?.gpra_b_4f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              daysSet={"gpra_b_4d_days"}
              days={substanceUse2?.gpra_b_4d_days}
              legend="Other evidence-based intervention"
              confirmation={substanceUse2?.gpra_b_4d}
              setConfirmation={"gpra_b_4d"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              removeError={removeError}
              numberError={validationErrors.gpra_b_4d}
              numberErrorType="gpra_b_4d"
              showDays={substanceUse2?.gpra_b_4d === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_4e || substanceUse2?.gpra_b_4f
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Did not receive any intervention for a diagnosed stimulant use disorder"
              }
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_b_4e
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_4e}
              onChange={(e) => {
                removeError("gpra_b_4e")
                if (e.value) {
                  updateState(
                    "gpra_b_4e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("4")
                  )
                } else {
                  updateState(
                    "gpra_b_4e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_4e}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_4e} />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Client does not report such a diagnosis"} required/>
            <Dropdown
              className={
                validationErrors.gpra_b_4f
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_4f}
              onChange={(e) => {
                removeError("gpra_b_4f")
                if (e.value) {
                  updateState(
                    "gpra_b_4f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearValues("4")
                  )
                } else {
                  updateState(
                    "gpra_b_4f",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_4f}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_4f} />
          </div>
        </div>
      )
    }
    if (question.field === "gpra_b_5") {
      return (
        <div className={gpraStyles.substanceUseContainer}>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. If you have been diagnosed with a tobacco use disorder, which FDA-approved medication did you receive for the treatment of this tobacco use disorder in the past 30 days? [CHECK ALL THAT APPLY.]`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              legend="Nicotine Replacement"
              confirmation={substanceUse2?.gpra_b_5a}
              setConfirmation={"gpra_b_5a"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              days={substanceUse2?.gpra_b_5a_days}
              daysSet={"gpra_b_5a_days"}
              removeError={removeError}
              numberError={validationErrors.gpra_b_5a}
              numberErrorType="gpra_b_5a"
              showDays={substanceUse2?.gpra_b_5a === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_5d || substanceUse2?.gpra_b_5e
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              legend="Bupropion"
              confirmation={substanceUse2?.gpra_b_5b}
              setConfirmation={"gpra_b_5b"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              days={substanceUse2?.gpra_b_5b_days}
              daysSet={"gpra_b_5b_days"}
              removeError={removeError}
              numberError={validationErrors.gpra_b_5b}
              numberErrorType="gpra_b_5b"
              showDays={substanceUse2?.gpra_b_5b === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_5d || substanceUse2?.gpra_b_5e
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <SubstanceUseRow
              entity={substanceUse2}
              setEntity={setSubstanceUse2}
              summaryDisabled={disabled}
              legend="Varenicline"
              confirmation={substanceUse2?.gpra_b_5c}
              setConfirmation={"gpra_b_5c"}
              confirmationOptions={confirmation}
              showRoute={false}
              showConfirmation
              days={substanceUse2?.gpra_b_5c_days}
              daysSet={"gpra_b_5c_days"}
              removeError={removeError}
              numberError={validationErrors.gpra_b_5c}
              numberErrorType="gpra_b_5c"
              showDays={substanceUse2?.gpra_b_5c === true}
              confirmationDisabled={
                substanceUse2?.gpra_b_5d || substanceUse2?.gpra_b_5e
              }
              defaultZero={question.defaultZero}
              required
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Did not receive an FDA-approved medication for a diagnosed tobacco use disorder"
              }
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_b_5d
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_5d}
              onChange={(e) => {
                removeError("gpra_b_5d")
                if (e.value) {
                  updateState(
                    "gpra_b_5d",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearTobaccoValues("5")
                  )
                } else {
                  updateState(
                    "gpra_b_5d",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_4e}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_5d} />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Client does not report such a diagnosis"} required/>
            <Dropdown
              className={
                validationErrors.gpra_b_5e
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={substanceUse2?.gpra_b_5e}
              onChange={(e) => {
                removeError("gpra_b_5e")
                if (e.value) {
                  updateState(
                    "gpra_b_5e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    clearTobaccoValues("5")
                  )
                } else {
                  updateState(
                    "gpra_b_5e",
                    e.value,
                    null,
                    null,
                    substanceUse2,
                    setSubstanceUse2,
                    null
                  )
                }
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              showClear={substanceUse2?.gpra_b_4f}
              disabled={disabled}
            />
            <FormError error={validationErrors.gpra_b_5e} />
          </div>
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={substanceUse2}
                    setEntity={setSubstanceUse2}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SUBSTANCE_USE_2}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, substanceUse2)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={substanceUse2}
                      setEntity={setSubstanceUse2}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SUBSTANCE_USE_2}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

SubstanceUse2.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}
SubstanceUse2.defaultProps = { showToolBar: true, disabled: false }

export default SubstanceUse2
